import { useContext } from "react";
import { PageNewState, RootComponentEditDialogContext } from ".";

export const useRootComponentEditDialogState = () => {
  const { pageState, setPageState } = useContext(
    RootComponentEditDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
